/**
 * 创建路由
 */

import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/views/Profile/Login'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [{
    name: 'Login',
    path: '/login',
    component: Login
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js